module.exports = __webpack_public_path__ + "img/refund_ing.36ca33a7.png";